// extracted by mini-css-extract-plugin
export var subtitle = "_bw-2";
export var title = "_bw-0";
export var titleNoWrap = "_bw-1";